import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import useCnaeContext from '../../contexts/CnaeContext';
import Bullet from '../atoms/Bullet';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '36px 24px',
    background: 'white',
    borderRadius: '8px',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    color: theme.palette.gray.darkGray

  },
  list: {
    listStyle: 'inside !important',
    listStyleType: 'circle !important',
    '& li': {
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      lineHeight: '120%'
    }
  },
  feedbackSearch: {
    marginBottom: '16px',
    '& span': {
      fontWeight: 'bold'
    },
  },
  sugestions: {
    fontWeight: 'bold',
    color: theme.palette.gray.midGray
  },
}));

export default function NotFound() {
  const classes = useStyles();
  const { valueInput } = useCnaeContext();

  return (
    <Box className={classes.container}>
        <Typography variant="body1" className={classes.feedbackSearch}>
          Sua pesquisa - <span>{valueInput}</span> - não encontrou nenhum resultado
        </Typography>
        <Typography variant="body2" className={classes.sugestions}>
          Sugestões
        </Typography>
        <ul className={classes.list}>
          <li><Bullet />Tenha certeza de que todas as palavras estão escritas corretamente.</li>
          <li><Bullet />Experimente palavras-chave diferentes.</li>
          <li><Bullet />Tente palavras-chave mais genéricas.</li>
          <li><Bullet />Verifique os filtros aplicados à pesquisa.</li>
        </ul>
      </Box>
  );
}
